<div class="access-denied-page">
  <img class="access-denied-bg" src="assets/404.png" alt="" aria-hidden="true" />
  <div class="access-denied-card">
    <h1 class="access-denied-heading">{{ translationService.translate('oopsText') }}</h1>
    <div class="access-denied-error-code">
      <span class="error-digit">4</span>
      <img class="access-denied-image" src="assets/icons/error-illustration-56586a.png" />
      <span class="error-digit">3</span>
    </div>
    <p class="access-denied-reason">{{ reason }}</p>
    <button mat-flat-button color="primary" class="access-denied-cta" (click)="goToHome()">
      {{ translationService.translate('returnToHomePageText') }}
    </button>
  </div>
</div>
